import { MarketPricesWrapper } from "./market-prices.style";
import { MarketPricesSection } from "./sections/market-prices.section";

export const MarketPricesPage = () => <MarketPricesWrapper><MarketPricesSection /></MarketPricesWrapper>;